import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "round-progress-bar-container" }

import { ref } from 'vue';
import { Chart, ArcElement, Tooltip, Title, ChartData } from 'chart.js';
import { DoughnutChart } from 'vue-chart-3';
import { computed } from 'vue';

// Chart.jsのコンポーネントを登録

export default /*@__PURE__*/_defineComponent({
  __name: 'RoundProgressBar',
  props: {
    progress: { default: 0 }
  },
  setup(__props: any) {

Chart.register(ArcElement, Tooltip, Title);

// props
const props = __props;

/**
 * チャートデータ
 * おもて部分のグラフデータ(進捗率)
 * 取引件数によって進捗率の受け入れタイミングが変わるのでcomputedで管理する
 */
const displayChartData = computed(() => {
  return createMainChartData(props.progress);
});

/**
 * 進捗率を表すチャートデータを作成する
 * @param progress -
 */
const createMainChartData = (progress: number): ChartData<'doughnut'> => {
  return {
    labels: ['progress', 'diff'], // データラベル(正味いらない)
    datasets: [
      {
        data: [progress, 100 - progress],
        backgroundColor: ['#64b5f6', 'transparent'],
        borderColor: ['#64b5f6', 'transparent'],
        borderRadius: 15,
      },
    ],
  };
};

// 背面部分のチャートデータを作成する(進捗の残り部分を表現する用)
const backgroundChartData = ref<ChartData<'doughnut'>>({
  datasets: [
    {
      data: [100],
      backgroundColor: ['#eeeeee'],
      borderColor: ['#eeeeee'],
    },
  ],
});

// // チャートのデザインなどのオプションを定義
const mainChartOptions = ref({
  responsive: true,
  cutout: '80%', // 円グラフの太さ
  // オプション項目
  plugins: {
    legend: {
      display: false,
    },
    tooltip: false,
  },
});

/**
 * 背面に設置しているチャートのデザインなどのオプションを定義
 */
const backgroundChartOptions = ref({
  responsive: true,
  cutout: '80%', // 円グラフの太さ
  // アニメーション
  animation: {
    animateRotate: false,
    animateScale: false,
  },
  // オプション項目
  plugins: {
    legend: {
      display: false,
    },
    tooltip: false,
  },
});

// ドーナツチャートの中央に進捗率を表示させるプラグインを定義
const ratioText = ref({
  id: 'ratioText',
  /**
   * 描画操作
   * @param chart - グラフ情報
   */
  beforeDraw(chart: any) {
    const {
      ctx,
      chartArea: { top, width, height },
    } = chart;
    ctx.save();
    //チャート描画部分の中央を指定
    ctx.fillRect(width / 2, top + height / 2, 0, 0);
    //フォントのスタイル指定
    ctx.font = 'bold 22px Roboto';
    ctx.fillStyle = '#1e92ef';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    //進捗率文字列をドーナツチャートの中央部に描画する
    ctx.fillText(`${props.progress}%`, width / 2, top + height / 1.9);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DoughnutChart), {
      "chart-data": backgroundChartData.value,
      options: backgroundChartOptions.value
    }, null, 8, ["chart-data", "options"]),
    _createVNode(_unref(DoughnutChart), {
      class: _normalizeClass('main-round-progress-bar'),
      "chart-data": displayChartData.value,
      options: mainChartOptions.value,
      plugins: [ratioText.value]
    }, null, 8, ["chart-data", "options", "plugins"])
  ]))
}
}

})